var map = {
	"./blue-logo.png": 26,
	"./close_white.png": 92,
	"./facebook_white.png": 27,
	"./google-plus.png": 28,
	"./line_white_v2.png": 29,
	"./logo@2x.png": 93,
	"./share-white.png": 94,
	"./swiper-next-white.png": 95,
	"./swiper-prev-white.png": 96,
	"./taiwan_color.png": 97,
	"./taiwan_line.png": 98,
	"./x.png": 99
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 124;


//////////////////
// WEBPACK FOOTER
// ./src/assets nonrecursive \.png$
// module id = 124
// module chunks = 1